import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MapComponent } from './map.component';
import { MapCanvasComponent } from './map-canvas.component';

@NgModule({
  declarations: [MapComponent, MapCanvasComponent],
  imports: [
    CommonModule
  ],
  exports: [
    MapComponent,
    MapCanvasComponent
  ]
})
export class MapModule { }
